export const environment = {
  production: true,
  api: '/api',
  host: '/',
  default_user: '',
  default_pwd: '',
  appVersion: require('../../package.json').version
};
